import React from "react";
import "./entryVideo.css";
import hk5 from "../../images/hk5.png";

function EntryVideo() {
  return (
    <div className="entryVideo">
      <img src={hk5} alt="HK Istanbul" />
    </div>
  );
}

export default EntryVideo;
